import { Separator as SeparatorPrimitive } from 'radix-ui';
import * as React from 'react';
import { cn } from '../../lib/utils';

/**
 * Separator — Generated from Figma Nimbus v3 Design System
 * @figma-node 118:2690
 * @figma-url https://www.figma.com/design/euN3FdxtNlCC8GiKC66YmG/Nimbus-v3--TBD-?node-id=118:2690
 *
 * Variants: Horizontal, Vertical
 *
 * Figma tokens:
 *   Stroke color: base/border — light #e8e8e8, dark #f9f9f9
 *   Stroke weight: border-width/border — 1px
 *   Vertical height: height/h-5 — 20px
 *
 * All colors extracted from Figma API — not guessed.
 */

interface SeparatorProps
  extends React.ComponentProps<typeof SeparatorPrimitive.Root> {}

function Separator({
  className,
  orientation = 'horizontal',
  decorative = true,
  ...props
}: SeparatorProps) {
  return (
    <SeparatorPrimitive.Root
      data-slot="separator"
      decorative={decorative}
      orientation={orientation}
      className={cn(
        'shrink-0',

        /*
         * Horizontal — Figma: LINE width=FILL height=0, strokeWeight=1, stroke=#e8e8e8
         * Renders as full-width 1px tall border
         */
        orientation === 'horizontal' && 'h-px w-full bg-nimbus-border',

        /*
         * Vertical — Figma: LINE width=0 height=20 (h-5), strokeWeight=1, stroke=#e8e8e8
         * Renders as 1px wide, 20px (h-5) tall border
         */
        orientation === 'vertical' && 'h-5 w-px bg-nimbus-border',

        className
      )}
      {...props}
    />
  );
}

export { Separator };
export type { SeparatorProps };
